import * as React from "react";
import {IBadgable} from "../../data/entities/IBadgable";
import {observer} from "mobx-react";

import './BadgeInfoBlock.pcss';

interface Props {
  badgable:IBadgable;
  solutionCurrentPoints?:number;
}

export const BadgeInfoBlock = observer((props:Props) => {

  if(!props.badgable.badgeUsed) {
    return null;
  } else {
    return (
      <div className="badgeInfoBock oh_baby">
        {props.badgable.badgeEarned ?
          <>
            <div className={"solution-badge"}>
              <img src={props.badgable.badge} />
            </div>
            <div className={"solution-badge-info"}>
              <h3>{props.badgable.name} badge earned!</h3>
              <p>{props.badgable.points} total points.</p>
            </div>
          </>
          :
          <>
            <div className={"solution-badge"}>
              <img src={props.badgable.badgePreview} />
            </div>
            <div className={"solution-badge-info"}>
              <h3>Earn the {props.badgable.name} badge</h3>
              {props.badgable.badgeInstructions && <p>{props.badgable.badgeInstructions}</p>}
              {undefined!==props.solutionCurrentPoints && props.solutionCurrentPoints>0 &&
                  <h4>
                    <strong>{props.solutionCurrentPoints} total point{props.solutionCurrentPoints>1?'s':''} &bull; </strong>
                    {props.badgable.badgeThreshold} point{props.badgable.badgeThreshold>1?'s':''} earns the badge
                  </h4>
              }
            </div>
          </>
        }
      </div>

    );
  }

});
